var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-popconfirm',{attrs:{"title":_vm.title},on:{"confirm":_vm.confirm}},[_c('el-button',{attrs:{"slot":"reference","type":_vm.type},slot:"reference"},[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }